import { Predicate, Predicates } from '.'
import {
  ApplicationImportance,
  allImportances
} from '../../../components/application-importance'

export const isApplicationImportance: Predicate<ApplicationImportance> =
  Predicates.getLiteralStringPredicate(allImportances)
